export const paginationConfig = { page: 1, perPage: 20 };

export const membersRoleOptions = [
  { role: "Admin", value: "Admin" },
  { role: "Owner", value: "Owner" },
  { role: "Member", value: "Member" },
  { role: "Guest", value: "Guest" },
];

export const restrictedIntegrations = ["zoom_info", "easyleadz"];